<template>
    <van-popup v-model="showTips" :lazy-render="false" close-icon="close" :close-on-click-overlay="false">
        <div ref="canvasWrapper" class="codeQr"></div>
        <div class="codeTxt">请使用微信扫码打开</div>
    </van-popup>
</template>

<script>
import {reqWxAuthorize} from '@/api/index.js'
import {isWeixin,wxAuthorize, removeQueryParam} from "@/utils/wx-authorize.js" //微信授权
import QRCode from 'qrcode'
import { Dialog } from 'vant';
export default {
  name:'tips',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      accessid:'', 
      openid:'', //微信用户openid   
      isLogin: false, //登录状态
      showTips:true,
    }
  },
  computed: {},
  watch: {},
  created () {
    if (process.env.NODE_ENV === 'development') {
      this.openid = 'oMNNz1r8h71OkSg8O_d9Zk49wxSc';
      this.accessid = '438720943';
      this.$store.commit("SET_OPENID", this.openid);
      this.$store.commit("SET_ACCESSID", this.accessid);
      this.showTips = false;
      if(this.openid && this.accessid){
        this.isLogin = true;
        console.log('您已登录，即将初始化数据');
        this.logged();
      } else {
        this.isLogin = false;          
        if(this.getQueryString("code")===null){
          console.log('获取code');
          wxAuthorize()
        }else{
          console.log('去登录');
          this.wxLogin();
        } 
      }
    } else if (process.env.NODE_ENV === 'production') {      
      if (isWeixin()) {
        this.showTips = false;  
        this.openid = this.$store.state.openid;
        this.accessid = this.$store.state.accessid;
        if(this.openid && this.accessid){
          this.isLogin = true;
          console.log('您已登录，即将初始化数据');
          console.log('this.accessid',this.accessid);            
          console.log('this.openid',this.openid);            
          this.logged();
        } else {
          console.log('this.getQueryString("code")',this.getQueryString("code"));            
          this.isLogin = false;          
          if(this.getQueryString("code")===null){
            console.log('获取code');
            wxAuthorize()
          }else{
            console.log('去登录');
            this.wxLogin();
          } 
        }
      }
    }
  },
  mounted() {
    //微信二维码显示  非微信环境显示
    if (isWeixin()) {
        this.showTips = false;          
      } else {
        this.generateCode();
        this.showTips = true;
      }
  },
  methods: {
    logged() {
      if (this.$parent && typeof this.$parent.loginInit === 'function') {
        this.$parent.loginInit();
      } else {
        console.log('父组件不存在 loginInit 方法');
      }
    },
    generateCode() {      
      console.log('window.location.href',window.location.href);
      QRCode.toCanvas(window.location.href, {
        width: 200,
        margin: 1
      }, (error, canvas) => {
        
        if (error) {
          console.error(error)
          return
        }        
        this.$refs.canvasWrapper.innerHTML = "";
        // 在canvas的父元素中插入canvas元素
        this.$refs.canvasWrapper.appendChild(canvas)
      })
    },
    async wxLogin(){
      console.log('this.getQueryString("code")',this.getQueryString("code"));
      console.log('this.$route.query.code',this.$route.query.code);
          
      const CODE = this.getQueryString("code");
      const STATE = this.getQueryString("state");
      console.log('STATE',STATE);
      if (STATE) { // 此页面为微信重定向过来且用户允许授权        
        let result = await reqWxAuthorize({code:CODE, drawid:26});
        if(result.flag=='success') {
          this.$store.commit("SET_OPENID",result.data.openid);
          this.$store.commit("SET_ACCESSID",result.data.accessid);
          this.openid = result.data.openid;
          this.accessid = result.data.accessid;       
          console.log('this.accessid',this.accessid);
          console.log('this.openid',this.openid);       
            
          this.isLogin = true;
          console.log('登录完毕，初始化数据');
          this.logged();
        } else { 
          console.log('window.location.href',window.location.href);
          
          Dialog.confirm({
            title: '消息提示',
            message: '刷新页面授权？',
          }).then(() => {
            // 获取当前URL
            const currentUrl = window.location.href;
            window.location.href = removeQueryParam(currentUrl, 'code');
          }).catch(() => {
            // on cancel
          });
        }
      } else {
        console.log('STATE 不存在');
      }      
    },
    getQueryString(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return r
    },
  },
}
</script>
<style scoped>

.codeQr {
    margin: 20px;
    margin-bottom: 10px;
    border-radius: 5px;
  }
.codeTxt{
    margin: 20px;
    margin-top: 0px;
    text-align: center;
    font-size: 30px;
}  
.van-popup{
    border-radius: 10px;
}
</style>
